import { render, staticRenderFns } from "./FollowUpStatusCpt.vue?vue&type=template&id=52dcdb88&"
import script from "./FollowUpStatusCpt.vue?vue&type=script&lang=ts&"
export * from "./FollowUpStatusCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports